import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

import CartButton from '@/components/cart-button';
import { useScrollProgress } from '@/hooks/useScrollProgress';

type ItemDetailHeaderProps = {
  hasImage?: boolean;
};

export default function ItemDetailHeader({ hasImage = false }: ItemDetailHeaderProps) {
  const navigate = useNavigate();
  const isScrolled = useScrollProgress(50);

  const showBackground = !hasImage || isScrolled;

  return (
    <header
      className={`fixed top-0 z-50 w-full transition-colors duration-200 ${
        showBackground ? 'bg-white border-b border-gray-100' : 'bg-transparent'
      }`}
    >
      <div className="flex items-center justify-between px-3 py-2.5 h-[50px]">
        {/* 뒤로가기 버튼 */}
        <button className="w-[30px] h-[30px] flex items-center justify-center" onClick={() => navigate(-1)}>
          <ArrowLeft
            className={`w-6 h-6 transition-colors duration-200 ${showBackground ? 'text-black' : 'text-white'}`}
          />
        </button>

        {/* 빈 공간 */}
        <div></div>

        {/* 장바구니 아이콘 */}
        <CartButton iconClassName={showBackground ? undefined : 'text-white'} />
      </div>
    </header>
  );
}
